import { makeStyles } from "@material-ui/core";
import { MasterButton, Title } from "App/Component/ui";
import { DISABLED_BUTTON_SUBMIT } from "App/constants";
import {
	defaultToastError,
	defaultToastSuccess,
	isNull,
} from "App/utils/helpers";
import { DrawerMaster } from "components/molecules";
import React, { useState } from "react";
import { postOrganisasi, updateOrganisasi } from "./helpers";
import OrganisasiForm from "./OrganisasiForm";

export default function OrganisasiPreview({
	open,
	setOpen,
	toggleDrawer,
	formDataInfo,
	setFormDataInfo,
	showModalLokasi,
	setShowModalLokasi,
	lokasi,
	setLokasi,
	formDataAlamat,
	setFormDataAlamat,
	alamat,
	setAlamat,
	formDataKontak,
	setFormDataKontak,
	telecom,
	setTelecom,
	setNewData,
}) {
	const useStyles = makeStyles({
		paper: {
			width: "80%",
		},
	});

	const styles = useStyles();

	const BUTTON_SUBMIT = {
		label: "SIMPAN",
		color: "lightgreen",
		state: false,
		disabled: false,
	};

	const [disabled, setDisabled] = useState(BUTTON_SUBMIT);

	const handleClickSubmit = async () => {
		//for Info Organisasi
		if (isNull(formDataInfo.kode)) {
			defaultToastError("Kode Organisasi Belum Di Isi");
			return false;
		} else if (isNull(formDataInfo.name)) {
			defaultToastError("Nama Organisasi Belum Di Isi");
			return false;
		} else if (isNull(lokasi.nama)) {
			defaultToastError("Lokasi Organisasi Belum Di Isi");
			return false;
		}
		if (formDataAlamat.available === true) {
			if (alamat.length === 0) {
				defaultToastError("Alamat Organisasi Belum Di Isi");
				return false;
			}
		}

		if (formDataKontak.available === true) {
			if (telecom.length === 0) {
				defaultToastError("Kontak Organisasi Belum Di Isi");
				return false;
			}
		}
		setDisabled(DISABLED_BUTTON_SUBMIT);
		if (formDataInfo.isUpdate === false) {
			const response = await postOrganisasi(
				isNull(formDataInfo.id_organization)
					? null
					: formDataInfo.id_organization,
				formDataInfo.kode,
				formDataInfo.name,
				formDataInfo.alias,
				formDataInfo.id,
				lokasi.id_location,
				formDataKontak.available === false ? [] : telecom,
				formDataInfo.active,
				formDataAlamat.available === false ? [] : alamat
			);
			if (response.state) {
				setDisabled(BUTTON_SUBMIT);
				defaultToastSuccess(response.message);
				setOpen(false);
				setNewData(1, 10, {
					parent_id_organization: formDataInfo.id_organization,
					name: "",
				});
			} else {
				setDisabled(BUTTON_SUBMIT);
				defaultToastError(response.message);
			}
		} else {
			const response = await updateOrganisasi(
				formDataInfo.id_organization,
				formDataInfo.parent_id_organization,
				formDataInfo.kode,
				formDataInfo.name,
				formDataInfo.alias,
				formDataInfo.id,
				lokasi.id_location,
				telecom,
				formDataInfo.active,
				alamat
			);
			if (response.state) {
				setDisabled(BUTTON_SUBMIT);
				defaultToastSuccess(response.message);
				setOpen(false);
				if (isNull(formDataInfo.parent_id_organization)) {
					setNewData();
				} else {
					setNewData(1, 10, {
						parent_id_organization: formDataInfo.parent_id_organization,
						name: "",
					});
				}
			} else {
				setDisabled(BUTTON_SUBMIT);
				defaultToastError(response.message);
			}
		}
	};

	return (
		<DrawerMaster
			open={open}
			toggleDrawer={toggleDrawer}
			widthList={"100%"}
			styles={{ paper: styles.paper }}
		>
			<Title title="Form Satu Sehat - Organisasi" />
			<OrganisasiForm
				formDataInfo={formDataInfo}
				setFormDataInfo={setFormDataInfo}
				showModalLokasi={showModalLokasi}
				setShowModalLokasi={setShowModalLokasi}
				lokasi={lokasi}
				setLokasi={setLokasi}
				formDataAlamat={formDataAlamat}
				setFormDataAlamat={setFormDataAlamat}
				alamat={alamat}
				setAlamat={setAlamat}
				formDataKontak={formDataKontak}
				setFormDataKontak={setFormDataKontak}
				telecom={telecom}
				setTelecom={setTelecom}
			/>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					gap: "10px",
				}}
			>
				<MasterButton
					className={"mt-1 mb-1"}
					type="button"
					color={"danger"}
					name={"Batalkan"}
					size="md"
					onClick={() => setOpen(false)}
				></MasterButton>
				<MasterButton
					className={"mt-1 mb-1"}
					type="button"
					color={disabled.color}
					name={disabled.label}
					size="md"
					onClick={() => (disabled.disabled ? null : handleClickSubmit())}
					disabled={disabled.disabled}
				></MasterButton>
			</div>
		</DrawerMaster>
	);
}
